import * as AlertDialog from "@radix-ui/react-alert-dialog";
import { cn } from "@/lib/cn";

interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  cancelLabel: string;
  confirmLabel: string;
  destructive?: boolean;
  onConfirm: () => void;
  testId?: string;
}

export const ConfirmDialog = ({
  open,
  onOpenChange,
  title,
  description,
  cancelLabel,
  confirmLabel,
  destructive = true,
  onConfirm,
  testId = "confirm-dialog",
}: ConfirmDialogProps) => (
  <AlertDialog.Root open={open} onOpenChange={onOpenChange}>
    <AlertDialog.Portal>
      <AlertDialog.Overlay className="fixed inset-0 z-50 bg-slate-950/60" />
      <AlertDialog.Content
        data-testid={testId}
        className="fixed left-1/2 top-1/2 z-50 w-[calc(100%-2rem)] max-w-md -translate-x-1/2 -translate-y-1/2 rounded-md border border-border bg-card p-5 shadow-lg animate-rise"
      >
        <AlertDialog.Title className="text-lg font-semibold tracking-tight">
          {title}
        </AlertDialog.Title>
        {description && (
          <AlertDialog.Description className="mt-1.5 text-sm text-muted-foreground">
            {description}
          </AlertDialog.Description>
        )}
        <div className="mt-5 flex justify-end gap-2">
          <AlertDialog.Cancel
            data-testid={`${testId}-cancel`}
            className="ops-focus rounded-sm border border-border bg-card px-3 py-1.5 text-sm font-medium transition-colors duration-150 hover:bg-[hsl(var(--surface-raised))]"
          >
            {cancelLabel}
          </AlertDialog.Cancel>
          <AlertDialog.Action
            data-testid={`${testId}-confirm`}
            onClick={onConfirm}
            className={cn(
              "ops-focus rounded-sm px-3 py-1.5 text-sm font-semibold transition-colors duration-150",
              destructive
                ? "bg-destructive text-destructive-foreground hover:bg-destructive/90"
                : "bg-primary text-primary-foreground hover:bg-primary/90",
            )}
          >
            {confirmLabel}
          </AlertDialog.Action>
        </div>
      </AlertDialog.Content>
    </AlertDialog.Portal>
  </AlertDialog.Root>
);
